<template>
  <component
    :is="packsOn ? 'button' : 'a'"
    v-if="SUPPORT_URL"
    class="support-btn"
    :type="packsOn ? 'button' : undefined"
    :href="packsOn ? undefined : SUPPORT_URL"
    :target="packsOn || SUPPORT_URL === '#' ? undefined : '_blank'"
    :rel="packsOn || SUPPORT_URL === '#' ? undefined : 'noopener noreferrer'"
    @click="onClick"
  >
    <svg class="paypal-mark" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M7.016 19.198h-4.2a.562.562 0 0 1-.555-.65L5.093.584A.692.692 0 0 1 5.776 0h7.222c3.417 0 5.904 2.488 5.846 5.5-.006.25-.027.5-.066.747A6.794 6.794 0 0 1 12.071 12H8.743a.69.69 0 0 0-.682.583l-.325 2.056-.013.083-.692 4.39-.015.087zm12.774-13.056c-.01.087-.01.175-.023.261a7.76 7.76 0 0 1-7.695 6.598H9.007l-.283 1.795-.013.083-.692 4.39-.134.843-.014.088H6.86l-.108.68a.562.562 0 0 0 .555.65h3.612c.34 0 .63-.249.683-.585l.952-6.032a.692.692 0 0 1 .683-.584h2.126a6.793 6.793 0 0 0 6.707-5.752c.306-1.95-.466-3.744-1.89-4.906a7.72 7.72 0 0 1-.272.471z"
      />
    </svg>
    <span>{{ t('support.tip') }}</span>
  </component>
  <DonateDialog v-if="open" @close="open = false" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from '../i18n/t'
import { paypalDonationsEnabled } from '../api/donations'
import { SUPPORT_URL } from '../supportUrl'
import DonateDialog from './DonateDialog.vue'

const { t } = useI18n()
const open = ref(false)
const packsOn = ref(false)

void paypalDonationsEnabled().then((on) => {
  packsOn.value = on
})

function onClick(event: MouseEvent): void {
  if (!packsOn.value) return
  event.preventDefault()
  open.value = true
}
</script>

<style scoped>
/* PayPal gold and navy are the brand mark, like the Discord blurple. */
.support-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px 0 12px;
  border: 0;
  border-radius: 20px;
  background: #ffc439;
  color: #003087;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-decoration: none;
  cursor: pointer;
  transition: filter var(--md-motion-short) var(--md-motion-standard);
}

.paypal-mark {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.support-btn:hover {
  filter: brightness(1.08);
}

.support-btn:focus-visible {
  outline: 2px solid var(--md-sys-color-primary);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .support-btn {
    transition: none;
  }
}
</style>
